import { call, put, takeLatest } from 'redux-saga/effects'
import { api } from '~/services/api'
import {
  getAllHashUserSuccess,
  getAllHashUserFailed,
  GET_ALL_HASh_USER_START,
} from '../../actions/hash'

/**
 * get list hash user
 * @param {any} params Params will be sent to server
 * @returns {Promise}
 */
const getListHashUserApi = (props) => {
  var uri = `/users/hash`
  return api.post(uri, props)
}

/**
 * [Worker]
 * Handle get data request and response
 * @param {object} action
 */
function* doGetListHashUser(action) {
  try {
    const response = yield call(getListHashUserApi, action?.payload)
    yield put(getAllHashUserSuccess(response?.data))
    // Call callback action if provided
    if (action.onSuccess) {
      yield action.onSuccess(response?.data)
    }
  } catch (error) {
    yield put(getAllHashUserFailed())
    // Call callback action if provided

    if (action.onError) {
      yield action.onError(error)
    }
  }
}

/**
 * [Watcher]
 * Watch get list hash user
 */
export default function* watchGetListHashUser() {
  yield takeLatest(GET_ALL_HASh_USER_START, doGetListHashUser)
}
